import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Close = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="close"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.2407 12.5001L21.6389 5.10154C22.1204 4.6203 22.1204 3.84218 21.6389 3.36094C21.1577 2.87969 20.3796 2.87969 19.8983 3.36094L12.4999 10.7595L5.10167 3.36094C4.62021 2.87969 3.84234 2.87969 3.3611 3.36094C2.87963 3.84218 2.87963 4.6203 3.3611 5.10154L10.7593 12.5001L3.3611 19.8987C2.87963 20.38 2.87963 21.1581 3.3611 21.6393C3.60093 21.8794 3.91627 22 4.23138 22C4.5465 22 4.86161 21.8794 5.10167 21.6393L12.4999 14.2407L19.8983 21.6393C20.1384 21.8794 20.4535 22 20.7686 22C21.0837 22 21.3988 21.8794 21.6389 21.6393C22.1204 21.1581 22.1204 20.38 21.6389 19.8987L14.2407 12.5001Z" />
    </svg>
  );
};
/* eslint-enable max-len */

Close.defaultProps = {
  className: null,
};

Close.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Close;
